import {advancedFilterScripts} from "./bg-advanced-filters.ts";

window.addEventListener('load', () => {
    advancedFilterScripts()
})